import { TableRow, NEW_TABLE_COLUMN_WIDTH } from './table.constants';

export function addAndRemoveRows(rows: TableRow[], numberOfRows: number) {
  const tableRows: TableRow[] = [];

  for (let i = 0; i < numberOfRows; i++) {
    if (i < rows.length) {
      tableRows.push({
        __typename: 'TableComponentRow',
        cells: rows[i].cells.map(c => ({
          __typename: 'TableComponentCell',
          value: c.value,
        })),
      });
    } else {
      tableRows.push({
        __typename: 'TableComponentRow',
        cells: rows[0].cells.map(c => ({
          __typename: 'TableComponentCell',
          value: {},
        })),
      });
    }
  }

  return tableRows;
}

export function addAndRemoveColumns(rows: TableRow[], numberOfColumns: number) {
  const tableRows = [...rows];

  const currentColumnCount = tableRows[0].cells.length;

  if (currentColumnCount > numberOfColumns) {
    tableRows.forEach(row => {
      row.cells.splice(numberOfColumns, currentColumnCount - numberOfColumns);
    });
  }

  if (currentColumnCount < numberOfColumns) {
    const diff = numberOfColumns - currentColumnCount;
    tableRows.forEach(row => {
      for (let i = 0; i < diff; i++) {
        row.cells.push({
          __typename: 'TableComponentCell',
          value: {},
        });
      }
    });
  }

  return tableRows;
}

export function updateTableRows(
  tableRows: TableRow[],
  numberOfRows: number,
  numberOfColumns: number
) {
  let rows = addAndRemoveRows(tableRows, numberOfRows);
  return addAndRemoveColumns(rows, numberOfColumns);
}

export function removeColumn(widths: number[], newNumberOfColumn: number) {
  const columnWidths = [...widths];
  const count = columnWidths.length - newNumberOfColumn;
  const removedItems = columnWidths.splice(columnWidths.length - count, count);
  const removedSum = removedItems.reduce((sum, width) => sum + width, 0);
  columnWidths[columnWidths.length - 1] =
    columnWidths[columnWidths.length - 1] + removedSum;
  return columnWidths;
}

export function addColumnsToTable(widths: number[], newNumberOfColumn: number) {
  const newColumnWidth = NEW_TABLE_COLUMN_WIDTH;
  const newWidths = [...widths];
  const count = newNumberOfColumn - newWidths.length;

  for (let i = 0; i < count; i++) {
    for (let j = newWidths.length - 1; j >= 0; j--) {
      if (newWidths[j] - newColumnWidth >= newColumnWidth) {
        newWidths[j] = newWidths[j] - newColumnWidth;
        break;
      }
    }
  }

  for (let i = 0; i < count; i++) {
    newWidths.push(newColumnWidth);
  }

  return newWidths;
}
